import * as React from "react"
import { useLocation } from '@reach/router';
import { storyblokEditable, StoryblokComponent } from "gatsby-source-storyblok";
import SearchTabs from "./searchTabs";
import TourList from "./tourList";
import { Lang, LangEnum } from "../utils/lang";
import SearchTabsJp from "./searchTabsJp";

const TourListPage = ({ blok }) => {
  // console.log(blok);
  const lang = Lang();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const labelArray = queryParams.get('label');
  var label = labelArray ? labelArray.split(',') : [];
  label = blok.label ? blok.label.value : label;

  const prefecture = blok.prefecture ? blok.prefecture : queryParams.get('prefecture');
  const destination = blok.destination ? blok.destination : queryParams.get('destination');
  const season = blok.season ? blok.season : queryParams.get('season');
  const typeOfTour = blok.typeOfTour ? blok.typeOfTour : queryParams.get('typeOfTour');
  const keyword = queryParams.get('keyword') ? queryParams.get('keyword').toLowerCase() : null;
  // console.log(prefecture, season, typeOfTour, keyword, label);

  return (
  <main {...storyblokEditable(blok)}>
    { 
    (blok.bannerImage?.filename || blok.title) && 
    <div className="relative h-[250px]">
      <img loading="lazy" src={`${blok.bannerImage?.filename}/m/0x500`} alt={blok.bannerImage.alt} className="absolute w-full h-[250px] object-cover"/>
      <div className="absolute inset-0 bg-gradient-to-t from-gray-950 to-transparent h-[250px]"></div>
      <div className="absolute inset-0 flex items-center justify-center h-[250px]">
        <h1 className="text-4xl text-white font-bold font-serif">{blok.title}</h1>
      </div>
    </div>
    }
    {blok.topBlocks?.map((nestedBlok) => (
      <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
    ))}
    { lang == LangEnum.JA && <SearchTabsJp hideBubble={false} /> }
    { lang == LangEnum.EN && <SearchTabs hideBubble={true} /> }
    <TourList tours={[]} adCards={blok.adCards} />
    {blok.body?.map((nestedBlok) => (
      <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} destination={destination}
        prefecture={prefecture} season={season} typeOfTour={typeOfTour} keyword={keyword} label={label} />
    ))}
  </main>
  )
};

export default TourListPage;
